import { Tour } from '../models/bookings';
import { Product } from '../models/products';

const normalizeName = (value?: string) => (value || '').trim().toLowerCase();

/** Whether a catalogue product is a fly+X package (first leg on the aviation entity). */
export const isPackageProduct = (product?: Product): boolean =>
    Boolean(product?.allowPackage || product?.packageCode || product?.tags?.includes('package'));

/** Match a booked tour back to a loaded catalogue product by code, then by name. */
export const findProductForBooking = (products: Product[], tour?: Tour): Product | undefined => {
    if (!tour) {
        return undefined;
    }
    if (tour.productCode) {
        const byCode = products.find((product) => product.productCode === tour.productCode);
        if (byCode) {
            return byCode;
        }
    }
    if (tour.productName) {
        const targetName = normalizeName(tour.productName);
        return products.find((product) => normalizeName(product.name) === targetName);
    }
    return undefined;
};

/** Human-readable names for each leg of a package, when we can resolve them from the store. */
export const getPackageLegNames = (product: Product, packageProducts: Product[]): string[] | undefined => {
    if (product.packageProductNames?.length === 2) {
        return product.packageProductNames;
    }
    const firstLeg = product.packageProductNames?.[0] || product.name;
    const packageProduct = product.packageCode
        ? packageProducts.find((pack) => pack.productCode === product.packageCode)
        : undefined;
    const secondLeg = product.packageProductNames?.[1] || packageProduct?.name;
    if (firstLeg && secondLeg) {
        return [firstLeg, secondLeg];
    }
    if (firstLeg) {
        return [firstLeg, 'included activity'];
    }
    return undefined;
};
